export const payload = {
  receiveMutation: 'RECEIVE_CUSTOMER',
  receivingMutation: 'RECEIVING_CUSTOMER',
  receiveMetadataMutation: 'RECEIVE_CUSTOMER_METADATA',
  receiveFailureMutation: 'RECEIVE_CUSTOMER_FAILURE',
  savingMutation: 'SAVING_CUSTOMER',
  saveFailureMutation: 'SAVING_CUSTOMER_FAILURE',
  incrementMutation: 'INCREMENT_CUSTOMER_COUNT',
  updatingMutation: 'UPDATING_CUSTOMER',
  updateFailureMutation: 'UPDATING_CUSTOMER_FAILURE',
  resetMetaMutation: 'RESET_CUSTOMER_META',
  clearMutation: 'CLEAR_CUSTOMER_STATE',
  moduleName: 'customer',
  endpoint: 'customers',
  nested: {
    address_contact: {
      receiveMutation: 'RECEIVE_ADDRESSES',
      listSchemaRequired: false,
      endpoint: 'addresses'
    },
    address_billing: {
      receiveMutation: 'RECEIVE_ADDRESSES',
      listSchemaRequired: false,
      endpoint: 'addresses'
    },
    address_mailing: {
      receiveMutation: 'RECEIVE_ADDRESSES',
      listSchemaRequired: false,
      endpoint: 'addresses'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/RouteComponents/Customers/actionPayload.js